<template>
  <div class="app-search-input">
    <form @submit.prevent="handleSearchSubmit">
      <label for="app-search">{{ title }}</label>
      <div class="input-group mb-3">
        <input
          id="app-search"
          v-model="search"
          type="text"
          class="form-control"
          :placeholder="placeholder">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="submit">
            <i class="fas fa-search" />
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AppSearchInput',
  props: {
    title: {
      type: String,
      default: 'Buscar'
    },
    placeholder: {
      type: String,
      default: 'Buscar por nombre o RUT'
    }
  },
  data() {
    return {
      search: ''
    };
  },
  methods: {
    handleSearchSubmit: function() {
      this.$emit('search', this.search);
    }
  }
};
</script>

<style scoped>

</style>
